import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {  toast } from 'react-toastify';
import Cryptochart from './Cryptochart';
import config from '../Config/Config';

export default function CryptoItem(props) {
    const { color, setColor} = props;
    const userId = localStorage.getItem("id");
    const token = localStorage.getItem('token');
    let navigate = useNavigate();
    let { id } = useParams();
    const [coindata, setCoindata] = useState({});
    useEffect(() => {
        fetch(`https://api.coingecko.com/api/v3/coins/${id}`)
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setCoindata(data)
            });
    }, []);

    async function addToFav() {
        if(token==null){
            toast('Login to Add Item', {
                position: "top-center",
                autoClose: 2000,
                type: "error",
                theme:"colored",
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                }) 
        }
        else{
            let data = await axios.post(config.apiUrladdfav, {
                _id: userId,
                name: coindata.name,
                image: coindata.image?.small,
                current_price: coindata.market_data?.current_price.inr,
                price_change_percentage_24h: coindata.market_data?.price_change_percentage_24h_in_currency.inr,
                market_cap: coindata.market_data?.market_cap.inr
            },
            toast('Added to favourites', {
                position: "top-center",
                autoClose: 2000,
                type: "success",
                theme:"colored",
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                })
            ) 
        }
        
    }

    return (
        <div style={{ marginTop: "60px" }} className='container'>
            <div style={{justifyContent:'space-between'}} className='row d-flex '>
                <div style={{borderRight:'2px solid grey', paddingRight:'5px'}} className="col-md-4 text-muted">
                    <h1 style={{fontSize: "80px" }}>{coindata.name}</h1>
                    <img style={{height:"280px", width:"280px"}} src={`${coindata.image?.large}`} alt="" />
                    <p>{coindata.description?.en.split('. ')[0]}.</p>
                    <h1 style={{ fontSize: "5vh" }}>Rank: {coindata.coingecko_rank}</h1>
                    <h1 style={{ fontSize: "5vh" }}>Current Price: ₹ {coindata.market_data?.current_price.inr.toLocaleString()}</h1>
                    <h1 style={{ fontSize: "5vh" }}>Market Cap: {coindata.market_data?.market_cap.inr.toLocaleString().toString().slice(0, -8)} M</h1>

                    <button type="button" className={color=='light'?'btn btn-warning my-4 mx-3':'btn btn-outline-warning my-4 mx-3'} onClick={addToFav}>Add to WishList</button>
                    <button type="button" onClick={() => navigate('/home')} className={color=='light'?'btn btn-warning my-4 mx-3':'btn btn-outline-warning my-4 mx-3'}>Go Back</button>
                </div>
                <div style={{marginTop:"100px"}} className="col-md-7">
                    <Cryptochart/>
                </div>

            </div>


        </div>
    )
}
